var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaValidator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 14,
    fill: "#4BAB71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 34.8008C23.4667 35.3341 23.5334 35.8008 23.5334 36.3341H32.4667C32.4667 35.8008 32.5334 35.2674 32.6 34.8008H23.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5333 37.666V39.9993C23.5333 40.3993 23.8 40.666 24.2 40.666H24.4C24.7333 42.3327 26.2667 43.666 28 43.666C29.8 43.666 31.2667 42.3993 31.6 40.666H31.8C32.2 40.666 32.4667 40.3993 32.4667 39.9993V37.666H23.5333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4667 12.3336C22.7334 12.6003 18.8 16.3336 18.2667 21.0669C18 23.7336 18.8 26.3336 20.4667 28.3336C21.7334 29.867 22.6667 31.6003 23.1334 33.4003H32.8667C33.3334 31.6003 34.2667 29.8003 35.5334 28.267C37 26.5336 37.8 24.3336 37.8 22.0669C37.8 16.5336 33.0667 12.0669 27.4667 12.3336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaValidator);
export default __webpack_public_path__ + "static/media/IdeaValidator.ca2899958185c980d31d243d7f96e328.svg";
export { ForwardRef as ReactComponent };